import { AudioRole } from '../core/player/role';
export function getPreferredTrackFromMetadata() {
    var preferredMetadataArr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], availableTrackArr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var preferredTrack;
    var myMap = new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = availableTrackArr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var availableTrack = _step.value;
            var _availableTrack_roles, _availableTrack_roles1;
            myMap.set(availableTrack.languageTag + '-' + !!((_availableTrack_roles = availableTrack.roles) === null || _availableTrack_roles === void 0 ? void 0 : _availableTrack_roles.includes(AudioRole.Description)), availableTrack);
            myMap.set(availableTrack.language + '-' + !!((_availableTrack_roles1 = availableTrack.roles) === null || _availableTrack_roles1 === void 0 ? void 0 : _availableTrack_roles1.includes(AudioRole.Description)), availableTrack);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = preferredMetadataArr[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var preferredMetadata = _step1.value;
            preferredTrack = myMap.get(preferredMetadata.languageTag + '-' + !!preferredMetadata.isAudioDescription);
            if (preferredTrack) {
                break;
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return preferredTrack;
}

//# sourceMappingURL=select-track.js.map